import {kmAppLink, SiteSlug} from "@pg-mono/km-routes";
import {KM_COMMON_TEST_IDS, KM_COMMON_TEST_IDS_MOBILE} from "@pg-mono/test-ids";

import {View} from "../../km_app/types/View";
import {NAVIGATION_LABELS} from "../constants/navigation_labels";

export type NavigationSectionView = View.APPLICATION_SENT | View.DASHBOARD | View.DISMISSED | View.FAVORITE;

export interface INavigationSection {
    labels: {
        bottomNav: string;
        sidebar: string;
    };
    path: string;
    testIds: {
        bottomNav: string;
        sidebar: string;
    };
    view: NavigationSectionView;
}

export const createDashboardSection = (site: SiteSlug): INavigationSection => ({
    labels: {
        bottomNav: NAVIGATION_LABELS.DASHBOARD.NAV_ITEM,
        sidebar: NAVIGATION_LABELS.DASHBOARD.NAV_ITEM
    },
    path: kmAppLink.site.dashboard({site}),
    testIds: {
        bottomNav: KM_COMMON_TEST_IDS_MOBILE.BOTTOM_NAV_DASHBOARD,
        sidebar: KM_COMMON_TEST_IDS.NAV_DASHBOARD
    },
    view: View.DASHBOARD
});

export const createNavigationSections = (site: SiteSlug): INavigationSection[] => [
    {
        labels: {
            bottomNav: NAVIGATION_LABELS.SECTION.FAVORITES.BOTTOM_NAV,
            sidebar: NAVIGATION_LABELS.SECTION.FAVORITES.SIDEBAR
        },
        path: kmAppLink.site.offers.favouritesWithParams({site}),
        testIds: {
            bottomNav: KM_COMMON_TEST_IDS_MOBILE.BOTTOM_NAV_FAVORITES,
            sidebar: KM_COMMON_TEST_IDS.NAV_FAVORITES
        },
        view: View.FAVORITE
    },
    {
        labels: {
            bottomNav: NAVIGATION_LABELS.SECTION.INQUIRIES.BOTTOM_NAV,
            sidebar: NAVIGATION_LABELS.SECTION.INQUIRIES.SIDEBAR
        },
        path: kmAppLink.site.offers.myInquiriesWithParams({site}),
        testIds: {
            bottomNav: KM_COMMON_TEST_IDS_MOBILE.BOTTOM_NAV_INQUIRIES,
            sidebar: KM_COMMON_TEST_IDS.NAV_APPLIED
        },
        view: View.APPLICATION_SENT
    },
    {
        labels: {
            bottomNav: NAVIGATION_LABELS.SECTION.DISMISSED.BOTTOM_NAV,
            sidebar: NAVIGATION_LABELS.SECTION.DISMISSED.SIDEBAR
        },
        path: kmAppLink.site.offers.dismissedWithParams({site}),
        testIds: {
            bottomNav: KM_COMMON_TEST_IDS_MOBILE.BOTTOM_NAV_DISMISSED,
            sidebar: KM_COMMON_TEST_IDS.NAV_DISMISSED
        },
        view: View.DISMISSED
    }
];

export const createBottomNavSections = (site: SiteSlug): INavigationSection[] => [createDashboardSection(site), ...createNavigationSections(site)];
import {kmAppLink, SiteSlug} from "@pg-mono/km-routes";
import {KM_COMMON_TEST_IDS, KM_COMMON_TEST_IDS_MOBILE} from "@pg-mono/test-ids";

import {View} from "../../km_app/types/View";
import {NAVIGATION_LABELS} from "../constants/navigation_labels";

export type NavigationSectionView = View.APPLICATION_SENT | View.DASHBOARD | View.DISMISSED | View.FAVORITE;

export interface INavigationSection {
    labels: {
        bottomNav: string;
        sidebar: string;
    };
    path: string;
    testIds: {
        bottomNav: string;
        sidebar: string;
    };
    view: NavigationSectionView;
}

export const createDashboardSection = (site: SiteSlug): INavigationSection => ({
    labels: {
        bottomNav: NAVIGATION_LABELS.DASHBOARD.NAV_ITEM,
        sidebar: NAVIGATION_LABELS.DASHBOARD.NAV_ITEM
    },
    path: kmAppLink.site.dashboard({site}),
    testIds: {
        bottomNav: KM_COMMON_TEST_IDS_MOBILE.BOTTOM_NAV_DASHBOARD,
        sidebar: KM_COMMON_TEST_IDS.NAV_DASHBOARD
    },
    view: View.DASHBOARD
});

export const createNavigationSections = (site: SiteSlug): INavigationSection[] => [
    {
        labels: {
            bottomNav: NAVIGATION_LABELS.SECTION.FAVORITES.BOTTOM_NAV,
            sidebar: NAVIGATION_LABELS.SECTION.FAVORITES.SIDEBAR
        },
        path: kmAppLink.site.offers.favouritesWithParams({site}),
        testIds: {
            bottomNav: KM_COMMON_TEST_IDS_MOBILE.BOTTOM_NAV_FAVORITES,
            sidebar: KM_COMMON_TEST_IDS.NAV_FAVORITES
        },
        view: View.FAVORITE
    },
    {
        labels: {
            bottomNav: NAVIGATION_LABELS.SECTION.INQUIRIES.BOTTOM_NAV,
            sidebar: NAVIGATION_LABELS.SECTION.INQUIRIES.SIDEBAR
        },
        path: kmAppLink.site.offers.myInquiriesWithParams({site}),
        testIds: {
            bottomNav: KM_COMMON_TEST_IDS_MOBILE.BOTTOM_NAV_INQUIRIES,
            sidebar: KM_COMMON_TEST_IDS.NAV_APPLIED
        },
        view: View.APPLICATION_SENT
    },
    {
        labels: {
            bottomNav: NAVIGATION_LABELS.SECTION.DISMISSED.BOTTOM_NAV,
            sidebar: NAVIGATION_LABELS.SECTION.DISMISSED.SIDEBAR
        },
        path: kmAppLink.site.offers.dismissedWithParams({site}),
        testIds: {
            bottomNav: KM_COMMON_TEST_IDS_MOBILE.BOTTOM_NAV_DISMISSED,
            sidebar: KM_COMMON_TEST_IDS.NAV_DISMISSED
        },
        view: View.DISMISSED
    }
];

export const createBottomNavSections = (site: SiteSlug): INavigationSection[] => [createDashboardSection(site), ...createNavigationSections(site)];
